import * as React from 'react';
import './CategoryPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ICategoryReduxFormState, initialCategoryState } from "../../../reducers/reactReduxForms/category";
import { IRegistrationElement, RegistrationFormComponent, IRegistrationGrid } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent, getFormProperty, getFormPropertyLabel } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveError, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, RadioButtonSetFormInput, SelectFormInput, DatePickerFormInput, DatePickerPartialFormInput, MaskedFormInput, NumberFormInput, CheckboxFormInput, StaticFormInput, GenericMultiFormGroup, ValidationMessage } from "../../../components/form/index";
import * as CategoryActions from '../../../actions/categories';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { Modal, NotificationAlert } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { Form, actions, Control } from 'react-redux-form';
import { ItemSettingsLayout } from '../../index';

interface ICategoryPageParams {
    categoryId: number;
}

interface ICategoryPageProps {

    form: Dtos.Category & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ICategoryReduxFormState;

    location: Location;
    categoryId: number;
    match: match<ICategoryPageParams>;
    history: History;

    // From state
    category: Dtos.Category;
    lookups: Dtos.Lookup[];

    loadingCategory: boolean;
    loadCategorySuccess: boolean;
    loadCategoryFailure: boolean;

    savingCategory: boolean;
    saveCategorySuccess: boolean;
    saveCategoryFailure: boolean;

    creatingCategory: boolean;
    createCategorySuccess: boolean;
    createCategoryFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ICategoryPageActions {
    clearCategory: CategoryActions.ICategoryClearActionCreator;
    loadCategory: CategoryActions.ICategoryLoadByIdActionCreator;

    saveCategory: CategoryActions.ICategorySaveActionCreator;
    createCategory: CategoryActions.ICategoryCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type CategoryPageProps = ICategoryPageProps & ICategoryPageActions;


const formName: string = "category";
const reduxFormName: string = "reduxForms.category";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}


class CategoryPage extends React.PureComponent<CategoryPageProps, any> {

    constructor(props: CategoryPageProps) {
        super(props);

        this.clearCategory = this.clearCategory.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadCategory,
            navigate,
            navigateReplace,
            categoryId,
            createCategory
        } = this.props;

        if (categoryId) {
            loadCategory(categoryId);
        } else if (!categoryId) {
            createCategory();
        }
    }

    componentWillReceiveProps(nextProps: CategoryPageProps) {
    }

    componentDidUpdate(prevProps: CategoryPageProps, prevState) {
        const {
            navigateReplace,
            categoryId,
            category,
            form,
            navigate,
            loadCategory,
            loadingCategory,
            loadCategorySuccess,
            createCategory,
            creatingCategory,
            createCategorySuccess,
            savingCategory,
            saveCategorySuccess,
            saveCategoryFailure,
            validationFailures
        } = this.props;

        if (categoryId && prevProps.categoryId != categoryId) {
            loadCategory(categoryId);
        }
        else if (!categoryId && prevProps.categoryId) {
            createCategory();
        }

        if (!loadingCategory && prevProps.loadingCategory) {
            if (loadCategorySuccess) {
                this.loadForm();
            }
            else {

            }
        }


        if (!savingCategory && prevProps.savingCategory) {
            if (saveCategorySuccess) {
                if (validationFailures && validationFailures.length > 0) {

                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {

                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);

                }
                if (form.saveAndReturn) {
                    navigate("/settings/item/itemcategories")
                } else if (!form.saveAndReturn && categoryId && categoryId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !categoryId && category && category.id > 0) {
                    navigate("/settings/item/itemcategories/" + category.id);
                }
            }
            else {

                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );

            }
        }

        if (!creatingCategory && prevProps.creatingCategory) {
            if (createCategorySuccess) {
                this.loadForm();
            }
            else {

            }
        }

    }

    componentWillUpdate(nextProps: CategoryPageProps) {
    }

    componentWillUnmount() {

        const {
            resetForm,
            loadForm
        } = this.props

        this.clearCategory();
        loadForm(reduxFormName, initialCategoryState);
        resetForm(reduxFormName);
    }

    clearCategory() {
        this.props.clearCategory();
    }

    showCategory(): boolean {
        const {
            loadingCategory,
            loadCategorySuccess
        } = this.props

        if (!loadingCategory && loadCategorySuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingCategory
        } = this.props;

        return <ItemSettingsLayout
            loading={loadingCategory}
            permission={Dtos.Permission.CategoriesView}>
            {this.renderContent()}
        </ItemSettingsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingCategory,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.CategoriesUpdate, Dtos.Permission.CategoriesCreate);
        const formDisabled: boolean = !hasPermission || savingCategory || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Category</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "category", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.Category) {
        const {
            saveCategory
        } = this.props;

        if (data) {
            let changes: Dtos.Institution = {} as Dtos.Institution;
            saveCategory(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.Category) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/item/itemcategories");
    }

    loadForm() {
        const {
            loadForm,
            category,
        } = this.props

        let extraData: Dtos.Category = {} as Dtos.Category;

        loadForm(reduxFormName, Object.assign({ ...category }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: CategoryPageProps): ICategoryPageProps => {

    let category: Dtos.Category | undefined = !(state.categories.formData instanceof Array) ? state.categories.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        categoryId: ownProps.match && ownProps.match.params.categoryId && ownProps.match.params.categoryId.toString() != "create" ? ownProps.match.params.categoryId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        category: category!,

        loadingCategory: state.categories.loadState && state.categories.loadState.status == RequestState.Pending,
        loadCategorySuccess: state.categories.loadState && state.categories.loadState.status == RequestState.Success,
        loadCategoryFailure: state.categories.loadState && state.categories.loadState.status == RequestState.Failure,

        savingCategory: state.categories.saveState && state.categories.saveState.status == RequestState.Pending,
        saveCategorySuccess: state.categories.saveState && state.categories.saveState.status == RequestState.Success,
        saveCategoryFailure: state.categories.saveState && state.categories.saveState.status == RequestState.Failure,

        creatingCategory: state.categories.createState && state.categories.createState.status == RequestState.Pending,
        createCategorySuccess: state.categories.createState && state.categories.createState.status == RequestState.Success,
        createCategoryFailure: state.categories.createState && state.categories.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.category,
        formState: state.categories.formState,
        formProperties: state.categories.formProperties,

        reduxFormState: state.reduxForms.formState.category,
        validationFailures: category ?
            state.categories.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): ICategoryPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadCategory: bindActionCreators(CategoryActions.LoadCategoryById, dispatch),
        clearCategory: bindActionCreators(CategoryActions.Clear, dispatch),

        saveCategory: bindActionCreators(CategoryActions.SaveCategory, dispatch),
        createCategory: bindActionCreators(CategoryActions.CreateCategory, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(CategoryPage);
